import { motion } from "framer-motion";
import { Plane, Stamp, Map } from "lucide-react";

const SERVICES = [
  {
    icon: Plane,
    title: "Ticket Bookings",
    body: "Confirmed reservations for domestic & international air travel, reliable express bus routes, and IRCTC railway tickets with optimal timings and seat choices.",
    footLabel: "Included channels",
    foot: "Flight comparisons · Bus sleeper berths · Tatkal & train bookings",
  },
  {
    icon: Stamp,
    title: "Visa & Passport Services",
    body: "Step-by-step paperwork scrutiny, appointment slots, tourist & business visa filings, and fast-track renewal assistance to avoid last-minute delays.",
    footLabel: "Support provided",
    foot: "Document checklists · Appointment bookings · Embassy filing help",
  },
  {
    icon: Map,
    title: "Custom Tour Planning",
    body: "Tailor-made itineraries crafted for family vacations, newlywed honeymoons, friend groups, and corporate team offsites across India and abroad.",
    footLabel: "Tailored for",
    foot: "Family groups · Corporate teams · Custom private departures",
  },
];

export const Services = () => (
  <section id="services" className="py-20 bg-stone-100 border-b border-stone-200" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mb-14">
        <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">One-Stop Travel Assistance</span>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 mt-2 font-serif-display">
          Complete booking &amp; documentation support
        </h2>
        <p className="text-stone-600 mt-3 text-base">
          No toggling between ten tabs or worrying about documentation rejections. Our team manages every leg of your itinerary.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="bg-white rounded-2xl p-8 border border-stone-200 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
            data-testid={`service-card-${i + 1}`}
          >
            <div>
              <s.icon className="w-8 h-8 text-amber-700 mb-4" strokeWidth={1.75} aria-hidden="true" />
              <h3 className="text-xl font-bold text-stone-900 mb-3">{s.title}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{s.body}</p>
            </div>
            <div className="mt-8 pt-6 border-t border-stone-100">
              <span className="text-xs font-semibold text-stone-700 uppercase tracking-wider block mb-2">{s.footLabel}</span>
              <p className="text-xs text-stone-700">{s.foot}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
